import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import {Router} from '@angular/router'
import { ApiService } from '../api.service';

@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.sass']
})
export class StoreComponent implements OnChanges {
  details_url: boolean
  single_category = false
  specific_category: string

  @Input() searchCat: string;
  @Input() searchVal: string;
  @Input() searchBool: boolean;
  @Input() reload: any;

  @Output() backFunk = new EventEmitter()

  catPages = {
    pageA: 1,
    pageW: 1,
    pageF: 1,
    pageI: 1,
    pageP: 1,
    pageR: 1,
    pageE: 1,
    pageY: 1,
    pageC: 1,
    pageS: 1
  }

  constructor(private router: Router, private apiService: ApiService) {
    if (this.router.url.includes("details")) {
      this.details_url = true
    }
    else {
      this.details_url = false
    }
   }

   ngOnChanges(): void {

  }

  catFunction(val): void {
    this.single_category = true
    this.specific_category = val
  }

  pageTurnedRight(IDS, selectCat): void {   
    if (IDS[1] === false) {
      this.catPages[selectCat] = 1
    }
    else {
      this.catPages[selectCat]++
    }
  }

  pageTurnedLeft(IDS, selectCat): void {
    if (IDS[0] === false) {
      this.catPages[selectCat] = IDS[2]
    }
    else {
      this.catPages[selectCat]--
    }
  }

  back(): void {
    this.single_category = false
    this.specific_category = ''
    this.backFunk.emit()
  }
}
